import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import * as dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { ReturnToSupplierHistoryAction } from './return-to-supplier-history.actions';
import { ReturnToSupplierHistoryService } from '../../service/return-to-supplier-history.service';

@Injectable()
export class ReturnToSupplierHistoryEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private service: ReturnToSupplierHistoryService
  ) {}

  loadReturnToSupplierHistoryListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReturnToSupplierHistoryAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect [ReturnToSupplierHistory] list request: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.service.getReturnToSupplierHistoryList(action.criteriaObj).pipe(
          map((data) => ReturnToSupplierHistoryAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  printReturnToSupplierHistoryRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReturnToSupplierHistoryAction.requestPrint),
      tap(({ returnNo }) => this.logger.debug('@Effect [ReturnToSupplierHistory] print: ' + returnNo)),
      switchMap(({ returnNo }) => {
        return this.service.print(returnNo).pipe(
          tap((blob) => {
            const filename = `${returnNo} ${dayjs().format('DDMMYYYY_HHmm')}.pdf`;
            saveAs(blob, filename);
          }),
          map(() => ReturnToSupplierHistoryAction.responsePrint()),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });
}
